const login = {
  login: 'ログイン',
  phone: '電話',
  email: 'メール',
  erCode: 'QRコード',
  phoneNo: '電話番号',
  sryx: 'メールアドレスを入力してください',
  password: 'パスワード',
  wjmm: 'パスワードを忘れましたか？',
  srmm: 'パスワードを入力してください',
  myzh: 'アカウントをお持ちでないですか？',
  ljzc: '今すぐ登録',
  cxsm: 'Bikingアプリを再起動してQRコードをスキャンしてください',
  xydl: 'ログインを許可するために、スマートフォンで操作してください',
  smewm: 'Bikingアプリでプロフィールアイコンをクリックし、右上のアイコンをタップしてQRコードをスキャンしてください',
  qtfs: '他の方法でログイン',
  ggsfyz: 'Google認証',
  bdsj: '電話番号が登録されました',
  bdyx: 'メールアドレスが登録されました',
  fsyzm: '認証コードを送信',
  wcyz: '確認してください',
  dlcg: 'ログイン成功しました。Bikingへようこそ！',
  bktb: 'セキュリティ上の理由から、アカウントの安全設定変更後の24時間は出金できません',
  fhdl: 'ログイン画面に戻る',
  jx: '続ける',
  cxfs: '再送する',
  gxmm: 'パスワードを更新',
  srsjh: '電話番号を入力してください',
  wjmm1: 'パスワードを忘れましたか？',
  sryxdz: 'メールアドレスを入力してください',
  srzqyx: '正しいメールアドレスを入力してください',
  sryzm: '認証コードを入力',
  czmm: 'パスワードをリセット',
  sbdyzm: '認証コードが届かない場合',
  srxmm: '新しいパスワードを入力してください',
  zczh: 'Bikingアカウントを登録',
  yqm: '招待コード（任意）',
  sryqm: '招待コードを入力してください',
  zc: '登録',
  yyzh: 'すでにアカウントをお持ちですか？',
  ljdl: '今すぐログイン',
  fsz: '認証コードが送信されました',
  next: '次へ',
  szmm: 'パスワードを設定',
  submit: '送信',
  zccg: '登録が成功しました！'

}
const download = {
title: '多様なゲームおよび<br/>暗号通貨取引プラットフォーム',
  subTitle: 'BiKingでは最大100種類の仮想通貨取引が可能です',
  xzbw: 'なぜBiKingを選ぶのか',
  czzz: 'BiKingはお客様の財富の創出、増加、保管をサポートします',
  download: 'App Storeでダウンロード',
  downloadtf: 'TestFlightでダウンロード',
  cjqxz: 'スーパーサインダウンロード',
  cjq: 'スーパーサイン{index}',
  bdxz: 'ローカルでのダウンロード',
  ggpxz: 'Google Playでダウンロード',
  advantageTitle1: 'トップクラスの性能 · 高速取引',
  subTitleSubTitle1: 'ロンドン証券取引所のテクノロジーによる超低遅延、高速マッチング',
  advantageTitle2: '資産保護 · 最高のセキュリティ',
  subTitleSubTitle2: 'BiKingはCCSS基準に準拠し、資産とデータのセキュリティを保障',
  advantageTitle3: '24時間体制のサービス',
  subTitleSubTitle3: 'システムの正常運用を保証し、24時間体制のカスタマーサービスを提供',
  qhidxq: 'ID切り替えの詳細紹介',
  step1: 'ステップ1',
  step2: 'ステップ2',
  step3: 'ステップ3',
  step4: 'ステップ4',
  step5: 'ステップ5',
  step6: 'ステップ6',
  step7: 'ステップ7',
  step8: 'ステップ8',
  step9: 'ステップ9',
  step10: 'ステップ10',
  azBiking: 'App StoreからBiKingをインストール',
  dlxz: '中国本土以外のApp IDをお持ちの場合、直接ログインしてください',
  fdlid: '中国本土以外のApp IDを準備してください',
  yxfshq: '中国本土以外のApp IDをお持ちでない場合は、以下の方法を試してみてください',
  qhid: 'App StoreでApple IDを切り替える',
  dk: '1.開く',
  ysjtx: 'App Storeアプリを開き、右上のアイコンをタップ',
  cxsrmm: '2.ログアウトをタップしてから、再びApple IDとパスワードを入力',
  wfdl: '* 「ログインできません」と表示される場合は、IDを切り替えた回数が多すぎる可能性があります。別のIDに切り替えるか、数時間後に再試行してみてください。IDがロックされている場合は、認証するか、別のIDに切り替えて再試行が必要です',
  azapp: 'アプリをインストール',
  storesh: '1.ログインに成功すると、自動的に適切な地域のApp Storeに移動し、「BiKing」を検索して「入手」ボタンをクリックしてアプリのインストールを開始します',
  jxxz: '中国本土以外のApple IDを持っている、続ける',
  jxxz1: 'ダウンロードを続行する',
  way1: '方法1',
  wayTitle1: '自分で登録、安全安心',
  wayBtn1: '登録方法を確認',
  way2: '方法2',
  wayTitle2: 'プラットフォームの参考ID（便利かつ迅速）',
  wayBtn2: '参考IDを確認する',
  way3: '方法3',
  wayTitle3: '国/地域のガイド（自由に切り替え可能）',
  wayBtn3: '購入方法を見る',
    
  ckzh: '中国本土以外のApple ID 参考アカウント',
  jgck: '以下は参考のための海外地域のIDです',
  jjfz: '（アカウントまたはパスワードをクリックしてコピーできます）',
  zh: 'アカウント',
  mm: 'パスワード',
  xxxl: 'お使いの携帯情報の漏洩を防ぐため',
  dlicloud: '上記のApple IDを使用してiCloudにログインしないでください',
  tczh: '参考Apple IDでアプリをダウンロードした後は、必ずそのアカウントからログアウトしてください',
  cfsy: '電話番号を登録しないでください。そうしないとIDは再利用できません',
  jrql: 'QRコードをスキャンしてグループチャットに参加',
  lxkf: 'カスタマーサポートに連絡する',
    
  zjzc: '自分で海外IDを登録する',
  registerStep1: 'ステップ1：Apple IDのホームページを開く',
  registerStep2: 'ステップ2：メールを認証する',
  registerStep3: 'ステップ3：App Storeアカウントをログアウトする',
  registerStep4: 'ステップ4：新しく登録したIDでStoreにログインする',
  gwzcwz: 'Safariブラウザを開いて、Apple公式ウェブサイトの登録ページにアクセスしてください：',
  yzdzyx: 'すべての情報を入力し、続行をクリックすると、Apple IDの確認メールが送信されます。受信したメールに記載されたコードを入力してください。',
  tjfkfs: 'その後、自動的にApple ID管理ページに移動します（読み込みに時間がかかるかもしれません）。管理ページに入ると、支払いと配送をクリックし、次のページで支払い方法を追加します。',
  mgsfzsc: 'ここがポイントです。支払い方法が「なし」であることを確認してください。国または地域はアメリカまたは登録したい地域に設定し、その他の情報は適当に入力してください。ただし、できるだけ英語で入力することをお勧めします。州/都市をアラスカに設定することで、免税地域であり、Appの購入も免税で行えます。具体的な個人情報はウェブサイトで生成できます：アメリカ身分証生成',
  gxdqxx: '入力が完了したら、更新をクリックして地域情報を更新します。',
  zhxx: '1. App Storeに進み、右上隅のアイコンをタップしてアカウントページに進みます。',
  djwc: '2. 画面を一番下までスクロールし、「ログアウト」をタップしてアカウントをログアウトし、「完了」をタップします。',
  jrzhdl: '1. 再度右上隅のアイコンをタップしてアカウントログインページに進みます。',
  zhmmdl: '2. アカウントとパスワードを入力し、「ログイン」をタップしてログインします。',
  jydlcg: '3. 認証コードを入力し、確認が完了すると、Apple IDでのログインが成功します。',
  jysssd: '取引はいつでもどこでも可能です',
  smewm: 'QRコードをスキャン',
  xiazai: 'ダウンロード',
  huodong: 'イベント',
  title1: 'BiKing 多様なゲーム',
  title2: 'および仮想通貨取引プラットフォーム',
  open: '「BiKing」アプリで開く',
  ggzx: 'お知らせセンター',
  lscb: 'オンチェーン入金',
  fbrj: '法定通貨入金',
  tgaq: 'ユーザーに安全で信頼性のあるサービスの提供に努めます',
  wdjmzc: '安定した暗号通貨デリバティブ取引サービスを提供',
  szhbjy: '私たちは暗号通貨取引のプロフェッショナルです',
  yxhsjh: '電子メール/電話番号で登録',

  appBetaTag: 'BETA版正式リリース',
  appHeroTitle: 'アプリ全面アップグレード',
  appHeroSubtitle: 'BiKingトレードの新たな航路を切り開く',
  tryNow: '今すぐ体験',
  downloadBikingApp: 'Bikingアプリをダウンロード',
  roadmapStageMeta: '/{total} {phase}',
  roadmapPhase1: '第1段階',
  roadmapPhase2: '第2段階',
  roadmapPhase3: '第3段階',
  roadmapPhase4: '第4段階',
  roadmapPhase5: '第5段階',
  roadmapVisionTitle: 'ビジュアル刷新',
  roadmapVisionDesc: '新デザイン言語 · 高度な操作性 · 没入型インターフェース',
  roadmapVisionPoint1: '新デザイン言語',
  roadmapVisionPoint2: '高度な操作性',
  roadmapVisionPoint3: '没入型インターフェース',
  roadmapEngineTitle: 'パフォーマンスエンジン強化',
  roadmapEngineDesc: 'コアアーキテクチャ再構築 · ミリ秒級レスポンス · 高い安定性',
  roadmapEnginePoint1: 'コアアーキテクチャ再構築',
  roadmapEnginePoint2: 'ミリ秒級レスポンス',
  roadmapEnginePoint3: '高い安定性',
  roadmapBetaTitle: 'Beta開始',
  roadmapBetaDesc: '次世代取引システム · 超高速マッチング · 期間限定体験',
  roadmapBetaPoint1: '次世代取引システム',
  roadmapBetaPoint2: '超高速マッチング',
  roadmapBetaPoint3: '期間限定体験',
  roadmapGlobalTitle: 'プラットフォーム全面進化',
  roadmapAiTitle: 'AI取引時代',
  comingSoon: '近日公開',
  appCopyright: '© 2016-2026 BiKing. All rights reserved.',
  testFlight: 'Test Flight',
  appStore: 'App Store',
  googlePlay: 'Google Play',
  superSign: 'スーパーサイン',
  chooseDownload: 'ダウンロード方法を選択',
  downloadAddr1: 'ダウンロードアドレス1',
  downloadAddr2: 'ダウンロードアドレス2',
  downloadCancel: 'キャンセル',
  apkLocalDownload: 'APKをダウンロード',
  entryBetaTitle: 'Beta版公開中',
  entryBetaSubtitle: '最新機能をいち早く体験',
  entryBetaTitleFull: 'Beta版公開中 — 最新機能をいち早く体験しましょう！',
  entryDownloadNow: '今すぐダウンロード',
  entryTagNew: 'New',
  entryClose: '閉じる',

}
export {login, download}


// WEBPACK FOOTER //
// ./src/i18n/lang/login/ja_JP.js